import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import {motion} from 'framer-motion'
export const About = () => {
  return (
    <>
    <Box  display={'flex'} justifyContent={'center'} textAlign={'center'} width={{sm:'300px',ls:'600px',lg:'900px', xl:'600px'}} margin={'3rem auto'}> 
    <motion.div initial={{ opacity: 0 }}
  whileInView={{ opacity: 1,transition:{duration: 1}}}>
    <Text fontSize={{sm:'1rem',ls:'1.5rem', lg:'1.5rem',xl:'2rem'}}>
    <Text as={'h2'} fontSize={{sm:'1.5rem',lg:'2rem',xl:'2rem'}} fontWeight={'900'} color={'#000'} margin={'1rem 0rem'}>Un poco sobre mí...</Text> 
Tengo 21 años y actualmente estudio <b>Diseño en FADU-UBA. </b> 
Me capacité en el área de <b>Marketing en Coder House</b> y es de lo que trabajo.
    </Text>
    </motion.div>
    </Box>

    <Box display={'flex'} justifyContent={'center'} textAlign={'center'} width={{sm:'300px',ls:'600px',lg:'900px', xl:'600px'}} margin={'3rem auto'}>
<motion.div initial={{ opacity: 0 }}
  whileInView={{ opacity: 1,transition:{duration: 1}}}>
    <Text fontSize={{sm:'1rem',ls:'1.5rem', lg:'1.5rem',xl:'2rem'}}>
    <Text as={'h2'} fontSize={{sm:'1.5rem',lg:'2rem',xl:'2rem'}} fontWeight={'900'} color={'#000'} margin={'1rem 0rem'} >Te preguntarás... Qué hace un CM?</Text> 
    Un Community es la persona encargada de <b>gestionar redes sociales. </b> 
Me voy a ocupar de <b>construir, ampliar y administrar</b> tu comunidad online. 
Gestiono la identidad y la imagen de tu marca manteniendo 
relaciones <b>estables y duraderas</b> con tu público.
Cuento con las herramientas analíticas necesarias para medir a los usuarios y entenderlos. 
    </Text>
</motion.div>
    </Box>
    </>
  )
}
